import classnames from "classnames";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../button";
import { Label } from "../label";

import styles from "./FileInput.module.scss";

export const FileInput = ({
  className,
  size = "md",
  color,
  label,
  postFiles,
  files = [],
  ...rest
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
  color?:
    | "primary"
    | "primary-ultralight"
    | "secondary"
    | "secondary-ultralight";
  label?: string;
  postFiles: (files: File[]) => void;
  files?: File[];
  multiple?: boolean;
  error?: string | null;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const inputClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const { t } = useTranslation();

  return (
    <div className={classnames("tw-w-full", className)}>
      {label && (
        <Label
          className="tw-mb-2"
          onClick={() => inputClick()}
          disabled={false}
          htmlFor={""}
        >
          {label}
        </Label>
      )}
      <div className="tw-relative tw-flex tw-w-full tw-flex-col tw-items-start sm:tw-flex-row sm:tw-items-center">
        <input
          multiple
          type="file"
          className={classnames("tw-invisible tw-absolute tw-left-0 tw-top-0")}
          ref={inputRef}
          value={""}
          {...rest}
          onChange={(e) => {
            postFiles([...(e.target.files ?? [])]);
          }}
        />
        <Button
          variant="outlined"
          size={size}
          className={classnames(styles.button, "tw-whitespace-nowrap")}
          onClick={() => {
            inputClick();
          }}
        >
          {t("iaq.fileUpload.uploadFilesCta")}
        </Button>
        <div
          className={classnames(
            "tw-mt-2 tw-text-[0.875rem] tw-font-semibold tw-leading-6 tw-text-[rgba(0,0,0,0.35)] sm:tw-ml-4 sm:tw-mt-0",
          )}
        >
          {t("iaq.fileUpload.acceptedFileTypesMessage")}
        </div>
      </div>
    </div>
  );
};
